export const BASE_URL = 'onboarding';
